const isEmpty = (value: any): boolean => {
  if (Array.isArray(value)) {
    return value.length === 0
  } else if (typeof value === "object" && value !== null) {
    return Object.keys(value).length === 0
  } else if (typeof value === "string") {
    return value.trim().length === 0
  } else {
    return value === undefined || value === null
  }
}

export const arePropsEmpty = (props: Record<string, any>): boolean => {
  for (const key in props) {
    if (
      props.hasOwnProperty(key) &&
      props[key] !== undefined &&
      !isEmpty(props[key])
    ) {
      return false
    }
  }
  return true
}
